export default class ScrollAnime{

    constructor(){
        this._init();
    }

    _init(){
        this._setToggleClassOnce();
    }
    
    _setToggleClassOnce(){
        const options = {
            threshold: 0.35
        };
        
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.intersectionRatio > options.threshold){
                    entry.target.classList.add('-viewed');
                    observer.unobserve(entry.target);
                }
            });
        }, options);
        
        [...document.querySelectorAll('.js-scroll-class')].forEach($target => {
            observer.observe($target);
        });
    }
}
